import { GlobalContext } from 'Context/GlobalContext/AppContext';
import { useContext, useEffect, useState } from 'react';
import api from 'services/api';

export default function useToggleActive(document, setToRefresh) {
  const { setValidationModal, user, setResponseMsg, setLoading } = useContext(GlobalContext);
  const [active, setActive] = useState(false);

  useEffect(() => {
    setActive(document?.Ativo); //Intern control of the toggle
  }, [document]);

  function submitStatus(value) {
    //Closure the value and send the returned function to be executed on Validate Modal
    return () =>
      api
        .postStatus(user, document.ID, !value, document.TipoDoc)
        .then(() => setToRefresh(Date.now()))
        .catch((error) => {
          console.error(error);
          setResponseMsg({ isVisible: true, error: true, msg: error.message });
        })
        .finally(() => setLoading(false));
  }

  function handleActive(value) {
    //Send info and callback to the Validate Modal
    setValidationModal({
      isVisible: true,
      title: 'Mudança de Status',
      text: 'Tem certeza de que deseja alterar o status atual para',
      emphasis: value ? 'Inativo?' : 'Ativo?',
      callback: submitStatus(value),
    });
  }

  return { active, handleActive };
}
